module.exports = __webpack_public_path__ + "static/media/sidekick-badge.6a316f44.svg";